import React from 'react';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';
import TotalsDisplay from './TotalsDisplay'; // nuevo componente

interface TableFooterProps {
  table?: any;
  actions?: any;
  readOnly?: boolean;
}

const TableFooter: React.FC<TableFooterProps> = ({ table, actions, readOnly = false }) => {
  const { form } = useBasePurchase();
  const headerGroup = table?.headerGroups?.[0];
  const renderedColumns = headerGroup?.headers?.length || 1;
  const colSpan = actions ? renderedColumns + 1 : renderedColumns;

  return (
    <tfoot>
      <tr className="bg-gray-50 dark:bg-gray-800 border-t border-stroke dark:border-strokedark">
        <td colSpan={colSpan} className="px-6 pt-6">
          <div className="flex justify-end">
            <TotalsDisplay documentTypeId={form.documentType?.id} form={form} readOnly={readOnly} />
          </div>
        </td>
      </tr>
    </tfoot>
  );
};

export default TableFooter;
